import { checkIsAfterDate, checkTheSameDate } from 'aa_common/front-end/helpers'
import { DEPRECIATION_METHOD_CODE } from 'common/constants'

export const matchDateConditions = (usageStartedAt?: string, transitionAt?: string) => {
  if (!transitionAt) return false
  if (!usageStartedAt) return false
  if (checkTheSameDate(usageStartedAt, transitionAt)) return false
  return !checkIsAfterDate(usageStartedAt, transitionAt)
}

export const matchDepreciationConditions = (dMethod: DEPRECIATION_METHOD_CODE) => {
  return [
    DEPRECIATION_METHOD_CODE.OLD_STRAIGHT_LINE,
    DEPRECIATION_METHOD_CODE.OLD_DECLINING_BALANCE,
    DEPRECIATION_METHOD_CODE.BULK_EQUAL_INSTALLMENT_METHOD,
    DEPRECIATION_METHOD_CODE.AVERAGE_USAGE_PERIOD,
    DEPRECIATION_METHOD_CODE.LEASE_PERIOD_STRAIGHT_LINE,
    DEPRECIATION_METHOD_CODE.DEFERRED_EQUAL_INSTALLMENT,
  ].includes(dMethod)
}

export const shouldRenderDepreciationMonth = (
  dMethod: DEPRECIATION_METHOD_CODE,
  usageStartedAt?: string,
  transitionAt?: string
) => {
  return matchDateConditions(usageStartedAt, transitionAt) && matchDepreciationConditions(dMethod)
}
